/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
export enum ProductType {
  software = 'software',
  hardware = 'hardware',
  connectivity = 'connectivity'
}

export interface Product {
  id: number
  code: string
  name: string
  type: ProductType
  description?: string
  active: boolean
  meta?: { allowed_subtypes?: string[] }
  created_at: string
  updated_at: string
}
